import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import RangeSliderBorderRadius from "../../../UI/RangeSliderBorderRadius";
const RangeSliderValueResolutionUI =  ({ callbackSliderValue, objectValue,objectName,displayName ,}) => {

     const dispatch = useDispatch();  
     const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
            {
              
              dispatch({type: "CURSOR",payload:true  });
          
              dispatch({type: "CURSORTEXT",payload:CursorText})
              dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
              dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
            }
             
            const handleMouseLeave = () => {
              
              dispatch({type: "CURSOR",payload:false})
          
              dispatch({type: "CURSORTEXT",payload:""})
          
              dispatch({type: "CURSORTEXTBG",payload:""})
              dispatch({type: "CURSORTEXTCOLOR",payload:""})
            
          
          }
 const [resolution, setPxPercent] = useState(objectValue?.resolution?objectValue?.resolution:"px");

 return(<>
 <div style={{display:"flex",justifyContent:"space-around",marginTop:"15px"}}><h4>{displayName} </h4>
                                          <div style={{display:"flex",justifyContent:"space-around"}}>
                              <RangeSliderBorderRadius resolution={resolution}  setSliderVal={(val)=>{ 
                                 
              callbackSliderValue({value:val,resolution:resolution},objectName)}} 
               sliderVal={objectValue?.value} />
                                <div style={{height:"50px" ,width:"90px"}}> 
                              <div class="input-card-outer"style={{
                                   
                                    transition: 'transform 3s ease, opacity 3s ease',
                                  borderRadius:"25px",padding:"0px"}} >
                                                            
                                                            <div  style={{display:"flex",justifyContent:"space-around"}}>
                                                                    
                                           
                                            <label onMouseEnter={
                                                               ()=>handleMouseEnter("#fff","#333","")}
                                                onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"} >
                                                              <div style={{display:"flex",justifyContent:"space-between"}} >
                                                            %
                                                                                       
                                                               </div> 
                                                <input type="radio" title="Color Theme"   checked={resolution=="%"?"yes":""}
                                     className="input-textbox"  value="%"  name={objectName+"1"}
                                     onChange={e=>{setPxPercent("%")}}/>
                                          <span class={"boxCardBorder-two"}></span> </label> 
                                            <label onMouseEnter={
                                                               ()=>handleMouseEnter("#fff","#333","")}
                                                onMouseLeave={handleMouseLeave} className={"boxCard-outer-two"}>
                                                              <div style={{display:"flex",justifyContent:"space-between"}} >
                                                              px                        
                                                                                       
                                                               </div> 
                                                <input type="radio" title="Color Theme"   checked={resolution=="px"?"yes":""}
                                     className="input-textbox"  value="px"  name={objectName+"1"} 
                                     onChange={e=>{setPxPercent("px")}}/>
                                          <span class={"boxCardBorder-two"}></span> </label> 
                                          </div>  </div></div></div>
                                 </div> 
                                 </>)

    } 
    export default RangeSliderValueResolutionUI;
